import store from '../store/'

export const packagesApi = {
    getAll () {
        return axios.get('/api/packages')
    },
}
